// ABOUTME: SPEC-57 — Figma-authored geometry and copy for the manual reel-view toggle (data only).
// ABOUTME: R5's "Watches variant" rename was reverted 2026-09-11 — the label is Figma's own "Carousel".

import { reelShortName } from '../../CollectionStage/pieceEnvelope';

// D-7: above STAGE_OVERLAY_Z (62, Projectionist/index.js) and STAGE_FADE_Z (63,
// useStageTransition.js) so the widget survives the SPEC-53 black fade exactly as the CC bar and
// mic do (owner ruling A1); below OverlayPortal's own default (65) and the rail (80).
export const VIEW_TOGGLE_Z = 64;

// Figma 424:12 / 424:14 children — identical box on both compositions.
export const BUTTON = Object.freeze({
  h: 76, padX: 38, radius: 37.333, font: 37.333, lineHeight: 1.02, blurPx: 10, dimOpacity: 0.5,
});

// Column + row rhythm. DESKTOP: 424:9/424:173 (gap 24 / stack 18 / bottom 18 above the bar) —
// unaffected by the mobile-frame fix below.
export const DESKTOP = Object.freeze({
  leftPct: (850.667 / 3840) * 100, gapX: 24, gapY: 18, gutterAboveBar: 18,
  maxWidthPct: (2138.667 / 3840) * 100,
});

// MOBILE — corrected: the shipped build measured 424:322/424:447, a DIFFERENT mobile frame
// (bottom-anchored, wrapped rows) that Figma file ABo9VOjbq9aZ9iz3OfncVV also contains, and which
// collides with the bottom-anchored mobile point-tag row (PointTagLayer/CaptionOverlay already own
// that band during a chapter). The correct mobile frame is 427:23 (open) / 427:166 (closed):
// top-left anchored, one button per row, in the OPHION wordmark's own row.
//
// 427:23/166 Frame 181 (pill): x 37 y 112 w 173 h 76 — IDENTICAL in both the open and the closed
// frame, so the pill's authored position never moves between states; the column grows downward
// under it instead of the pill sliding up a bottom gutter (D-4 re-decided, mobile only; desktop's
// bottom-anchored D-4 is unchanged above). This also removes OQ-1's "collapsed vs. open gutter"
// question: there is no gutter above a bar in a top-anchored frame, so nothing is re-decided per
// state (OQ-1 re-decided, see the SPEC's own text).
//
// 427:23 Frame 189 (the open column): x 37 y 212 — 212 - (112 + 76) = 24 above the pill — and its
// 7 children sit at y 0/100/200/300/400/500/600 inside it, i.e. a 100 pitch = BUTTON.h (76) + a 24
// gap. One authored number (24) therefore governs every mobile vertical gap: pill-to-column and
// button-to-button alike.
//
// D-6/OQ-4 (mobile tag-band reserve) is unaffected as a DECISION — CHAPTER_BUTTONS' `hasTags`
// derivation in useReelViewToggle.js is untouched — but is no longer consumed by mobile's position:
// the fully open column now tops out at authored y 888 (112 + 76 + 24 + 7*76 + 6*24), nowhere near
// the bottom-anchored tag row/CC bar at any viewport, so there is nothing left to clear.
export const MOBILE = Object.freeze({
  leftInset: 37, top: 112, gapY: 24,
});

export const MIN_LABEL_PX = 11; // mobileGeometry.MIN_TEXT_PX, same legibility floor
export const PILL_LABEL = 'Views';

/**
 * Figma-authored chapter labels, in the frames' left-to-right order. Chapter ids are the
 * manifest's own (reelSpecTransform.SECTION_TO_CHAPTER_ID) — `collection`'s label is Figma's own
 * "Carousel" (R5's "Watches variant" rename reverted, owner, 2026-09-11); nothing downstream keys
 * off the label either way.
 */
export const CHAPTER_BUTTONS = Object.freeze([
  { id: 'idle', label: 'Hero', node: '424:15' },
  { id: 'watch_360', label: '360', node: '424:17' },
  { id: 'dial', label: 'Dial', node: '424:19' },
  { id: 'movement', label: 'Movement', node: '424:21' },
  { id: 'exploded', label: 'Exploded View', node: '424:23' },
  { id: 'crown', label: 'Crown', node: '424:25' },
  { id: 'collection', label: 'Carousel', node: '424:27' }, // R5 reverted (owner, 2026-09-11) — id unchanged
]);

/** The collection button's two labels, both derived at runtime — no brand literal (D-9),
 *  the same `reelShortName` App.js already uses to build "Back to Vesper". Owner, 2026-09-11:
 *  the short name alone ("Vélos"), not "Vélos Collection" — matches `returnLabel`'s own shape. */
export const collectionLabel = (title) => reelShortName(title);
export const returnLabel = (railTitle) => reelShortName(railTitle);
